import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
// import { ReclamationActionDetailCodes, ReclamationActionDetailType } from 'constants.js'; // V2 : scénario
// import FormControl from '@mui/material/FormControl'; // V2 : scénario
// import FormLabel from '@mui/material/FormLabel'; // V2 : scénario
// import RadioGroup from '@mui/material/RadioGroup'; // V2 : scénario
// import FormControlLabel from '@mui/material/FormControlLabel'; // V2 : scénario
// import Radio from '@mui/material/Radio'; // V2 : scénario
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';

const styles = theme => ({
    formControl: {
        width: '100%'
    }
});

/* V2 — Scénarios RECENT (SCERECENT). La valeur envoyée à Gescom est le numéro (1 à 4).
const scenarios = [
    { valeur: 1, libelle: 'Avoir uniquement' },
    { valeur: 2, libelle: 'Avoir et préparation' },
    { valeur: 3, libelle: 'Avoir et nouvelle vente' },
    { valeur: 4, libelle: 'Avoir + Préparation + Nouvelle vente' }
];
*/

class ReclamationSurBonDeVenteDialogContent extends React.Component {

    // V2 : choix du scénario
    // state = {
    //     scenario: null
    // };

    componentDidMount() {
        // Action valide sans saisie : le scénario n'est pas demandé en V1 (SCERECENT non transmis).
        this.props.onChange({
            code: this.props.action.code,
            details: []
        });
    }

    // V2 : construction du détail scénario
    // getActionData(newState) {
    //     const { action } = this.props;
    //
    //     if (newState.scenario === null) {
    //         return null;
    //     }
    //
    //     const scenario = scenarios.find(x => x.valeur === Number(newState.scenario));
    //
    //     return {
    //         code: action.code,
    //         details: [{
    //             code: ReclamationActionDetailCodes.ReclamationSurBonDeVenteScenario,
    //             type: ReclamationActionDetailType.ChoixSimple,
    //             libelle: 'Scénario RECENT',
    //             position: 0,
    //             valeurString: scenario.libelle,
    //             valeurInteger: scenario.valeur
    //         }]
    //     };
    // }
    //
    // handleChange = (event) => {
    //     let newState = {
    //         ...this.state,
    //         [event.target.name]: event.target.value
    //     };
    //     this.setState(newState);
    //     this.props.onChange(this.getActionData(newState));
    // }

    render() {
        return (
            <DialogContent>
                <Typography variant="body1" gutterBottom>
                    Déclencher une réclamation sur bon de vente (RECENT) dans Gescom pour ce dossier.
                </Typography>

                {/* V2 — Choix du scénario (SCERECENT)
                <FormControl component="fieldset" className={this.props.classes.formControl}>
                    <FormLabel component="legend">Scénario : </FormLabel>
                    <RadioGroup
                        aria-label="scenario"
                        name="scenario"
                        value={this.state.scenario}
                        onChange={this.handleChange}
                    >
                        {scenarios.map((s) => (
                            <FormControlLabel key={s.valeur} value={s.valeur.toString()} control={<Radio />} label={s.libelle} />
                        ))}
                    </RadioGroup>
                </FormControl>
                */}
            </DialogContent>
        );
    }
}

ReclamationSurBonDeVenteDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

export default withStyles(styles)(ReclamationSurBonDeVenteDialogContent);
